import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Toolbar, Button, Box } from '@material-ui/core';
import { TemplateActionButtonsProps } from 'typings';
import useTemplateStyles from '../../styles/templateStyle';

const ActionButtonsMobile: React.FC<TemplateActionButtonsProps> = ({ templatePageContent, exportPDF, onSaveToNL, loading }) => {
  const classes = useTemplateStyles();
  const handleExport = () => {
    exportPDF();
  };
  const handleSaveToNL = () => {
    onSaveToNL();
  };

  return (
    <Box className={classes.mobileFooter}>
      <Toolbar className={classes.mobileFooterToolbar}>
        <Button color='primary' onClick={handleExport} fullWidth className={classes.mobileActionButton}>
          <div className={classes.iconWithLabel}>
            <StaticImage
              width={24}
              layout='constrained'
              placeholder='tracedSVG'
              src='../../assets/TemplatePreview/pdf.svg'
              alt='Download PDF'
            />
            <span style={{ color: '#000' }}>{templatePageContent.DownloadPDFLabel}</span>
          </div>
        </Button>
        <Button
          onClick={handleSaveToNL}
          disabled={loading}
          fullWidth
          className={`${classes.mobileActionButton} ${classes.mobileShareButton}`}
        >
          <div className={classes.iconWithLabel}>
            <StaticImage
              width={24}
              layout='constrained'
              placeholder='tracedSVG'
              src='../../assets/TemplatePreview/sync_alt_blue.png'
              alt='Save to Novade Lite'
            />
            {templatePageContent.SaveToNovadeLiteLabel}
          </div>
        </Button>
      </Toolbar>
    </Box>
  );
};

export default ActionButtonsMobile;
